
export const text = `Have you ever seen an error in a video you've seen before? You could swear it's a trick of the mind, an error on your computer. A soundbite chirps, you hear something like a stray radio signal, one of the actors in the video just stands there silently when they're supposed to be speaking?

This is Quorum Quantified, and today we're going to discuss Quorumtube.


`